const AllBranches = () => import("../branch/views/AllBranches.vue");
const BranchForm = () => import("../branch/views/BranchForm.vue");
const EditBranch = () => import("../branch/views/EditBranch.vue");

export default [
  {
    name: "view-all-branch",
    path: "view-all",
    component: AllBranches,
    meta: {
      permissions: ["view all stations"],
    },
  },
  {
    name: "edit-branch",
    path: "edit/:id",
    component: EditBranch,
    meta: {
      permissions: ["edit station"],
    },
  },
  {
    name: "create-branch",
    path: "create",
    component: BranchForm,
    meta: {
      permissions: ["create station"],
    },
  },
];
